export const FETCH_NOTE_HISTORY = 'FETCH_NOTE_HISTORY'
export const FETCH_NOTE_HISTORY_START = 'FETCH_NOTE_HISTORY_START'
export const FETCH_NOTE_HISTORY_SUCCESS = 'FETCH_NOTE_HISTORY_SUCCESS'
export const FETCH_NOTE_HISTORY_ERROR = 'FETCH_NOTE_HISTORY_FAIL'
